module.exports = __webpack_public_path__ + "static/media/1.c2be2939.jpg";